<h2>
    {{ reportItem.title.fullLabel }}
    <app-tooltip data-html2canvas-ignore [text]="reportItem.title.summary"></app-tooltip>
</h2>
<mat-form-field *ngIf="reportItem.variations.length > 1">
    <mat-select [(ngModel)]="reportItem.selectedVariationCode">
        <mat-option *ngFor="let variation of reportItem.variations" [value]="variation.code">
            {{ variation.text?.shortLabel }}
        </mat-option>
    </mat-select>
</mat-form-field>

<ng-container *ngFor="let variation of reportItem.variations">
    <ng-container *ngIf="variation.code === reportItem.selectedVariationCode">
        <app-report-chart *ngIf="variation.displayType !== chartType.datatable" [variation]="variation"></app-report-chart>
        <app-report-datatable *ngIf="variation.displayType === chartType.datatable" [variation]="variation"></app-report-datatable>
    </ng-container>
</ng-container>
